import React from 'react'
import CV from '../../acesset/new_resume.pdf'
import { Magnet } from '../reactbits'

const CTA = () => {
  return (
    <div className='cta'>
        <Magnet strength={0.2}>
          <a href={CV} download className='btn'>Download CV</a>
        </Magnet>
        <Magnet strength={0.2}>
          <a href='#contact' className='btn btn-primary'>Let's Talk</a>
        </Magnet>
    </div>
  )
}

export default CTA
